import VISIT_TYPE from '_constants/VISIT_TYPE';
import API_URLS from '_constants/URLS';
import VISIT_TYPE_LINKS from '_constants/VISIT_TYPE_LINKS';

export const VISIT_TYPE_LABELS = {
  [VISIT_TYPE.ASSESSMENT]: 'Assessment',
  [VISIT_TYPE.ENFORCEMENT]: 'Enforcement',
  [VISIT_TYPE.EDUCATION]: 'Education',
};

export const VISIT_TYPE_TONES = {
  [VISIT_TYPE.ASSESSMENT]: 'assess',
  [VISIT_TYPE.ENFORCEMENT]: 'enforce',
  [VISIT_TYPE.EDUCATION]: 'edu',
};

export const fileExt = (fileName) => {
  if (!fileName) return '';
  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop().toUpperCase() : '';
};

export const isImage = (item) => item.kind === 'image';

export const absoluteUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/')) return `${window.location.origin}${url}`;
  return url;
};

/**
 * Route to the visit a media item came from — /assessment/:id, /enforcement/:id or /education/:id,
 * picked by the item's visit type. Null when the item carries no visit id, or a type with no page.
 *
 * The same three-line expression lived in the tile, the preview modal, the review panel and the
 * retailer-view visit row; it is one helper now so a route change lands in one place.
 */
export const visitPath = (item) =>
  item?.visitId && VISIT_TYPE_LINKS[item.visitType] ? `${VISIT_TYPE_LINKS[item.visitType]}/${item.visitId}` : null;

/* Route to a retailer's detail page. Null when the item does not carry the retailer (the galleries
   scoped to one retailer don't repeat it on every file). */
export const retailerPath = (item) => (item?.retailerId ? `${API_URLS.retailers}/${item.retailerId}` : null);
